import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/components/ui/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProspectForm"] */ "/app/src/modules/prospect/components/ProspectForm.tsx");
